var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildEstimateIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 89,
    viewBox: "0 0 146 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "build-estimate-illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "build-estimate-illustration_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.92456 4.26537H146V82.9976H4.92456V4.26537Z",
    fill: "#FFD204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.94957C0 2.66371 2.61475 0 5.8402 0H112.123C115.348 0 117.963 2.66372 117.963 5.94958V67.8676C117.963 71.1534 115.348 73.8171 112.123 73.8171H5.84021C2.61475 73.8171 0 71.1534 0 67.8676V5.94957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.123 0.743697H5.8402C3.01793 0.743697 0.730025 3.07444 0.730025 5.94957V67.8676C0.730025 70.7427 3.01793 73.0734 5.84021 73.0734H112.123C114.945 73.0734 117.233 70.7427 117.233 67.8676V5.94958C117.233 3.07445 114.945 0.743697 112.123 0.743697ZM5.8402 0C2.61475 0 0 2.66371 0 5.94957V67.8676C0 71.1534 2.61475 73.8171 5.84021 73.8171H112.123C115.348 73.8171 117.963 71.1534 117.963 67.8676V5.94958C117.963 2.66372 115.348 0 112.123 0H5.8402Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.94957C0 2.66371 2.61475 0 5.8402 0H112.123C115.348 0 117.963 2.66372 117.963 5.94958V12.6591H0V5.94957Z",
    fill: "#FFD204"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.123 0.743697H5.8402C3.01793 0.743697 0.730025 3.07444 0.730025 5.94957V11.9154H117.233V5.94958C117.233 3.07445 114.945 0.743697 112.123 0.743697ZM5.8402 0C2.61475 0 0 2.66371 0 5.94957V12.6591H117.963V5.94958C117.963 2.66372 115.348 0 112.123 0H5.8402Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0271 20.3107C12.0271 18.6678 13.3345 17.336 14.9472 17.336H103.874C105.487 17.336 106.794 18.6678 106.794 20.3107V26.2362C106.794 27.8791 105.487 29.211 103.874 29.211H14.9472C13.3345 29.211 12.0271 27.8791 12.0271 26.2362V20.3107Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.874 18.0797H14.9472C13.7376 18.0797 12.7571 19.0786 12.7571 20.3107V26.2362C12.7571 27.4684 13.7376 28.4673 14.9472 28.4673H103.874C105.083 28.4673 106.064 27.4684 106.064 26.2362V20.3107C106.064 19.0786 105.083 18.0797 103.874 18.0797ZM14.9472 17.336C13.3345 17.336 12.0271 18.6678 12.0271 20.3107V26.2362C12.0271 27.8791 13.3345 29.211 14.9472 29.211H103.874C105.487 29.211 106.794 27.8791 106.794 26.2362V20.3107C106.794 18.6678 105.487 17.336 103.874 17.336H14.9472Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0271 38.4059C12.0271 36.763 13.3345 35.4311 14.9472 35.4311H103.874C105.487 35.4311 106.794 36.763 106.794 38.4059V44.3313C106.794 45.9743 105.487 47.3061 103.874 47.3061H14.9472C13.3345 47.3061 12.0271 45.9743 12.0271 44.3313V38.4059Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.874 36.1748H14.9472C13.7376 36.1748 12.7571 37.1737 12.7571 38.4059V44.3313C12.7571 45.5635 13.7376 46.5624 14.9472 46.5624H103.874C105.083 46.5624 106.064 45.5635 106.064 44.3313V38.4059C106.064 37.1737 105.083 36.1748 103.874 36.1748ZM14.9472 35.4311C13.3345 35.4311 12.0271 36.763 12.0271 38.4059V44.3313C12.0271 45.9743 13.3345 47.3061 14.9472 47.3061H103.874C105.487 47.3061 106.794 45.9743 106.794 44.3313V38.4059C106.794 36.763 105.487 35.4311 103.874 35.4311H14.9472Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0271 57.632C12.0271 55.9891 13.3345 54.6572 14.9472 54.6572H103.874C105.487 54.6572 106.794 55.9891 106.794 57.632V63.5574C106.794 65.2004 105.487 66.5322 103.874 66.5322H14.9472C13.3345 66.5322 12.0271 65.2004 12.0271 63.5574V57.632Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.874 55.4009H14.9472C13.7376 55.4009 12.7571 56.3998 12.7571 57.632V63.5574C12.7571 64.7896 13.7376 65.7885 14.9472 65.7885H103.874C105.083 65.7885 106.064 64.7896 106.064 63.5574V57.632C106.064 56.3998 105.083 55.4009 103.874 55.4009ZM14.9472 54.6572C13.3345 54.6572 12.0271 55.9891 12.0271 57.632V63.5574C12.0271 65.2004 13.3345 66.5322 14.9472 66.5322H103.874C105.487 66.5322 106.794 65.2004 106.794 63.5574V57.632C106.794 55.9891 105.487 54.6572 103.874 54.6572H14.9472Z",
    fill: "#FFD204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57109 6.49352C9.57109 7.85119 8.49071 8.95179 7.158 8.95179C5.82529 8.95179 4.74491 7.85119 4.74491 6.49352C4.74491 5.13585 5.82529 4.03524 7.158 4.03524C8.49071 4.03524 9.57109 5.13585 9.57109 6.49352Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8269 6.49352C16.8269 7.85119 15.7465 8.95179 14.4138 8.95179C13.0811 8.95179 12.0007 7.85119 12.0007 6.49352C12.0007 5.13585 13.0811 4.03524 14.4138 4.03524C15.7465 4.03524 16.8269 5.13585 16.8269 6.49352Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0828 6.49352C24.0828 7.85119 23.0024 8.95179 21.6697 8.95179C20.337 8.95179 19.2566 7.85119 19.2566 6.49352C19.2566 5.13585 20.337 4.03524 21.6697 4.03524C23.0024 4.03524 24.0828 5.13585 24.0828 6.49352Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.828 12.6225H0.880419V11.8788H117.828V12.6225Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3284 31.9825C27.3284 31.7771 27.4918 31.6106 27.6934 31.6106L98.9943 31.6106C99.1959 31.6106 99.3593 31.7771 99.3593 31.9825C99.3593 32.1879 99.1959 32.3543 98.9943 32.3543H27.6934C27.4918 32.3543 27.3284 32.1879 27.3284 31.9825Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0962 51.8676C97.0962 51.6622 96.9328 51.4957 96.7312 51.4957L36.2569 51.4957C36.0553 51.4957 35.8919 51.6622 35.8919 51.8676C35.8919 52.0729 36.0553 52.2394 36.2569 52.2394L96.7312 52.2394C96.9328 52.2394 97.0962 52.073 97.0962 51.8676Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2909 31.9825C11.2909 31.7771 11.4543 31.6106 11.6559 31.6106H21.9287C22.1303 31.6106 22.2937 31.7771 22.2937 31.9825C22.2937 32.1879 22.1303 32.3543 21.9287 32.3543H11.6559C11.4543 32.3543 11.2909 32.1879 11.2909 31.9825Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.205 51.8676C110.205 51.6622 110.042 51.4957 109.84 51.4957H99.5673C99.3657 51.4957 99.2023 51.6622 99.2023 51.8676C99.2023 52.073 99.3657 52.2394 99.5673 52.2394H109.84C110.042 52.2394 110.205 52.073 110.205 51.8676Z",
    fill: "#343333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.575 64.438L121.003 75.892C121.226 76.0304 121.342 76.2935 121.296 76.5551C121.25 76.8166 121.051 77.0223 120.795 77.0725L115.997 78.0204C115.788 78.0615 115.614 78.2065 115.533 78.4062C115.452 78.6067 115.475 78.8346 115.594 79.0138L119.535 84.9283C119.732 85.222 119.656 85.6227 119.367 85.822L114.933 88.8886C114.644 89.0886 114.251 89.0119 114.055 88.7176L110.114 82.8031C109.995 82.6239 109.796 82.5182 109.583 82.5207C109.371 82.5239 109.174 82.635 109.06 82.8177L106.424 87.01C106.283 87.2342 106.022 87.3465 105.767 87.2941C105.511 87.2409 105.314 87.0341 105.27 86.772L101.623 65.0958C101.581 64.8472 101.686 64.5964 101.891 64.4548C102.096 64.3132 102.363 64.3064 102.575 64.438Z",
    fill: "#1A2250"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildEstimateIllustration);
export default __webpack_public_path__ + "static/media/build-estimate-illustration.9d5bfac2d536cbb005cd9f47c859d072.svg";
export { ForwardRef as ReactComponent };